/***
 * @file:
 * @Date: 2020-06-17 19:18:08
 * @author: manyao.zhu
 */
export const API = {
  // ç»å½
  login: `/pub/login`,
  // è·åç¨æ·ä¿¡æ¯
  getUser: `/cli/bus/client/get_user.do`,
  // è·åèååæéä¿¡æ¯
  getMenuAndAcess: `/cli/bus/client/get_user_modules.do`,
  //
  imgDown: '/pub/bus/file/image?fileId=', // å¾çå±ç¤º
  showImage: '/cli/bus/file/image?access_token=', // è¿ééè¦tokenåfileIdä¸¤ä¸ªåæ°

  // è·åå½åææç§æ·çæ¥å£
  getAllTenantId: '/cli/bus/client/get_tenants.do',
};
